import styled from 'styled-components'

const H1 = styled.h1`
    background: -webkit-linear-gradient(top, #695901 0 25%, #ffd700);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  filter: drop-shadow(2px 4px 8px #00000026);
  margin: 2rem 0;
`

export { H1 }